import React from 'react';
import {ImportContainerV2} from '../../Containers/ImportExportContainer';



const ImportV2 = (props) => {
	return (
		<ImportContainerV2 />
	);
}
export default ImportV2;